(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDeleteController',TestScheduleDeleteController);

    TestScheduleDeleteController.$inject = ['$uibModalInstance', 'entity', 'TestSchedule'];

    function TestScheduleDeleteController($uibModalInstance, entity, TestSchedule) {
        var vm = this;

        vm.testSchedule = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TestSchedule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
